import { NgClass } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import menuJson from '@assets/menu-items.json';
import { AuthService } from '@core/services/auth.service';
import { AnalyticsAuthService } from '@core/services/google-analytics/trackers/auth/ga-auth.service';
import { PaymentsTabsService } from '@features/payments/services/payments-tabs.service';
import { SOCIAL_NETWORKS } from '@shared/constants/social-networks';
import { MenuItem } from '@shared/interfaces/menu-item.interface';
import { filter } from 'rxjs';

@Component({
  selector: 'app-sidenav',
  imports: [NgClass],
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidebarComponent implements OnInit {
  currentPage: MenuItem | undefined;
  isSidebarVisible = false;
  menuItems = menuJson;
  userIconSrc = 'assets/icons/menu-user.svg';
  notificationIconSrc = 'assets/icons/notification.svg';
  readonly SOCIAL_NETWORKS = SOCIAL_NETWORKS;

  constructor(
    @Inject(Router) private readonly router: Router,
    private readonly _authService: AuthService,
    private readonly _paymentsTabService: PaymentsTabsService,
    private readonly _gAnalytics: AnalyticsAuthService,
  ) {}

  ngOnInit(): void {
    this.updateCurrentPage(this.router.routerState.snapshot.url);
    this.router.events
      .pipe(
        filter(
          (event: Event): event is NavigationEnd =>
            event instanceof NavigationEnd,
        ),
      )
      .subscribe((event: NavigationEnd) => {
        this.updateCurrentPage(event.urlAfterRedirects);
      });
  }

  updateCurrentPage(url: string) {
    this.currentPage =
      this.findMenuItemByRoute(this.menuItems.items, url) || undefined;
  }

  findMenuItemByRoute(items: MenuItem[], url: string): MenuItem | null {
    for (const item of items) {
      if (item.route && url.includes(item.route)) {
        return item;
      }
    }

    return null;
  }

  toggleSidebar() {
    this.isSidebarVisible = !this.isSidebarVisible;
  }

  navigateToPage(menuItem: MenuItem) {
    if (menuItem.route) {
      this.router.navigate([`${menuItem.route}`]).then(() => {
        this._paymentsTabService?.reset();
      });
    }
  }

  signOut() {
    this._gAnalytics.trackLogout();
    this._authService.signOut();
  }

  hasPermission(category: string): boolean {
    return this._authService.hasPermission(category);
  }
}
